import UnifiedSignupScreenName from '../UnifiedSignupScreenName';
import UnifiedSignupStartScreen from '../session-info/UnifiedSignupStartScreen';
import AbstractStartSignupScreen from './AbstractStartSignupScreen';

export default class FreeStartSignupScreen extends AbstractStartSignupScreen {
  public readonly screenName: UnifiedSignupScreenName = 'uss-start-free';

  public predicate(): boolean {
    return this.sessionInfo.value.startScreen.compareTo(UnifiedSignupStartScreen.freePlan)
      && this.sessionInfo.value.emailCheckCode === null;
  }

  // eslint-disable-next-line class-methods-use-this
  public isInitialScreen(): boolean {
    return true;
  }
}
